// import React from 'react';



import React, { useState, useEffect } from "react";
import "./App.css";
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import OwlCarousel from 'react-owl-carousel';
import Preheader from "./Preheader";
import Table from "./Table";
import Parters from "./Parters";
import Footer from "./Footer";
import Fixture from "./Fixture";
import teamplayer from './image/teamplayer.png'
import { Helmet } from "react-helmet";
import vaibhav from './playerimg/vaibhav r.jpg'
import pankaj from './playerimg/pankaj j.jpg'
import keshav from './playerimg/keshav d.jpg'
import hiten from './playerimg/hiten d.jpg'
import prince from './playerimg/prince y.jpg'
import rahul from './playerimg/rahul c.jpg'
import deepak from './playerimg/deepak p.jpg'
import rahuld from './playerimg/rahul d.jpg'
import piyash from './playerimg/piyash c.jpg'
import parth from './playerimg/parth b.jpg'
import nitesh from './playerimg/nitesh s.jpg'
import ajay from './playerimg/ajay r.jpg'
import ruveer from './playerimg/ruveer k.jpg'
import aryan from './playerimg/aryan d.jpg'
import parikshit from './playerimg/parikshit b.jpg'
import ayush from './playerimg/ayush k.jpg'
import aatre from './playerimg/aatre t.jpg'
import pradyuman from './playerimg/pradyuman s.jpg'
import varun from './playerimg/varun V.jpg'
import pratap from './playerimg/Pratap b.jpg'
import dhruv from './playerimg/dhruv k.jpg'
import shivam from './playerimg/Shivam g.jpg'
import himmat from './playerimg/himmat singh.jpg'
import bannernew from './image/bannerndt.jpg'
import banner2ndt from './image/banner2ndt.jpg'
import Insta from './Insta';
import ReelPlayer from './ReelPlayer';
import reel1 from './videos/1.mp4';
import reel2 from './videos/2.mp4';
import reel3 from './videos/3.mp4';
import reel2thumb from './image/reels2thumb.jpg';
import reel3thumb from './image/reels3thumb.jpg';
import reel1thumb from './image/reels1thumb.jpg';
import Banner from "./Banner";
// import partner from './image/sponsor.png's

function Home() {

  const [standings, setStandings] = useState([]);
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      const fetchStandings = async () => {
        try {
          const response = await fetch(
            'https://ndt-dev.katsamsoft.in/api/resource/DPL Standings?fields=["*"]'
          );
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          const data = await response.json();
  
          const sortedData = data.data.sort((a, b) => a.position - b.position);
  
          setStandings(sortedData);
          setLoading(false);
        } catch (error) {
          console.error("Error fetching data:", error);
          setLoading(false);
        }
      };
  
      fetchStandings();
    }, []); 



    const options5 = {
        loop: true,
        margin: 10,
        center: true,
        items: 3,
        nav: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 3
            },
            1000: {
                items: 3
            }
        }
    };
  
  const options = {
    loop: true,
    margin:25,
    nav: false,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    dots:false,
    center: true,
    responsive: {
      0: {
        items: 1.6
      },
      600: {
        items: 3
      },
      1000: {
        items: 4.2
      }
    }
  };
    const options2 = {
    loop: true,
    margin:25,
    nav: false,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    dots:false,
    center: true,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      1000: {
        items: 4
      }
    }
  };


  return (
    <>


<Helmet>
        <title>
 
        New Delhi Tigers DPLT20 Team 2025 | Watch Live Match on Jio Hotstar and Fancode| Official New Delhi Tigers Website

        </title>
        <meta
          name="title"
          content="New Delhi Tigers - Competing in the DPLT20"

        />
        <meta
          name="keywords"
          content=" New Delhi Tigers DPLT20 Team 2025 | Watch Live Match on Jio Hotstar and Fancode| Official New Delhi Tigers Website"
        />

        <meta
          name="description"
          content=" New Delhi Tigers DPLT20 Team 2025 | Watch Live Match on Jio Hotstar and Fancode| Official New Delhi Tigers Website
"
        />

        <link rel="canonical" href="https://newdelhitigers.com" />
      </Helmet>



    <Preheader/>


      <Banner />


  <Fixture/>

  <section className='standingtable'>
  <div class="overlay2"></div>

    <div class="container-fluid">
    <div className="newheading1">
  <h5>Standings</h5>
  <div className="line"></div>
</div>
      <div class="table-responsive">
      <table className="table table-bordered table-hover">
  <thead className="table-dark">
    <tr>
      <th className="text-center">SI NO.</th>
      <th></th>
      <th>TEAMS NAME</th>
      <th>P</th>
      <th>W</th>
      <th>L</th>
      <th className="mobilenone">T</th>
      <th className="mobilenone">+/-</th>
      <th className="mobilenone">PTS</th>
    </tr>
  </thead>
  <tbody>
                  {standings.length > 0 ? (
                    standings.map((team, index) => (
                      <tr  key={index}
                      className={team.team === "New Delhi Tigers" ? "highlight" : ""}>
                        <td className="text-center">{index + 1}</td>
                        <td>
                          <img
                            src={`https://ndt-dev.katsamsoft.in/${team.image}`}
                            alt={team.team}
                          />
                        </td>{" "}
                        <td>{team.team}</td>
                        <td>{team.matches}</td>
                        <td>
                        {team.won ? ` ${team.won} ` : '-'}
                        </td>
                        <td>
                        {team.lost ? ` ${team.lost} ` : '-'}
                        </td>
                        <td className="mobilenone">
                        {team.tied ? ` ${team.tied} ` : '-'}
                         </td>
                        <td className="mobilenone">  {team.score_diff ? ` ${team.score_diff} ` : '-'}</td>
                        <td className="mobilenone">   {team.points ? ` ${team.points} ` : '-'}</td>
                        
                        {/* Render other data accordingly */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3">Loading...</td>
                      <td colSpan="3"></td>
<td className="mobilenone"></td>
<td className="mobilenone"></td>
<td className="mobilenone"></td>
<td className="mobilenone"></td>


                    
                      
                    </tr>
                  )}
                </tbody>
</table>

      </div>
  </div>


    </section>

      {/* <section className="socialplatform"> 
  <div  className="socialmediamargin">

 <iframe src="https://widget.taggbox.com/157253"         style={{ width: '100%', height: '580px', border: 'none' }} 
     ></iframe>
    
      
      </div>   
      
        </section> */}

     
        <section className="playersider">

<div className="newheading1">
<h5>Squad</h5>
<div className="line"></div>
</div>


<OwlCarousel className="owl-theme" {...options}>
<div className='items'>
          <img src={himmat} className='img-fluid'/>
      </div>

      <div className='items'>
          <img src={vaibhav} className='img-fluid'/>
      </div>
      <div className='items'>
          <img src={pankaj} className='img-fluid'/>
      </div>
      <div className='items'>
          <img src={keshav} className='img-fluid'/>
      </div>
      <div className='items'>
          <img src={hiten} className='img-fluid'/>
      </div>
      <div className='items'>
          <img src={prince} className='img-fluid'/>
      </div>
      <div className='items'>
          <img src={rahul} className='img-fluid'/>
      </div>
      <div className='items'>
          <img src={deepak} className='img-fluid'/>
      </div>
      <div className='items'>
          <img src={rahuld} className='img-fluid'/>
      </div>
      <div className='items'>
          <img src={piyash} className='img-fluid'/>
      </div>

      <div className='items'>
          <img src={parth} className='img-fluid'/>
      </div>


      <div className='items'>
          <img src={nitesh} className='img-fluid'/>
      </div>

      <div className='items'>
          <img src={ajay} className='img-fluid'/>
      </div>
      <div className='items'>
          <img src={ruveer} className='img-fluid'/>
      </div>
      <div className='items'>
          <img src={aryan} className='img-fluid'/>
      </div>
      <div className='items'>
          <img src={parikshit} className='img-fluid'/>
      </div>
      <div className='items'>
          <img src={ayush} className='img-fluid'/>
      </div>
      <div className='items'>
          <img src={aatre} className='img-fluid'/>
      </div>
      <div className='items'>
          <img src={pradyuman} className='img-fluid'/>
      </div>
      <div className='items'>
          <img src={varun} className='img-fluid'/>
      </div>
      <div className='items'>
          <img src={pratap} className='img-fluid'/>
      </div>
      <div className='items'>
          <img src={dhruv} className='img-fluid'/>
      </div>
      <div className='items'>
          <img src={shivam} className='img-fluid'/>
      </div>


</OwlCarousel>


</section>

<div className="bannerhome">
        {/* <img src={bannernew} className="img-fluid" /> */}
        <img src={banner2ndt} className="img-fluid" />
      </div>

     <section className="playersider">

<div className="newheading1">
<h5>NDT TV</h5>
<div className="line"></div>
</div>


<OwlCarousel className="owl-theme" {...options2}>
<div className='items'>
          <ReelPlayer
            key={1}
            videoSrc={reel1}
            thumbnailSrc={reel1thumb}
       
        />
        
      </div>
      <div className='items'>
          <ReelPlayer
            key={2}
            videoSrc={reel2}
            thumbnailSrc={reel2thumb}
       
        />
        
      </div>
      <div className='items'>
          <ReelPlayer
            key={3}
            videoSrc={reel3}
            thumbnailSrc={reel3thumb}
       
        />
        
      </div>

      

</OwlCarousel>


</section>

{/* <New/> */}
     
<Parters/>
  <Footer/>




    </>
  );
}

export default Home;